import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/6_dogs-7/6_dogs-7"
 * Contains 6 texture(s)
 */
export class CardsFront6Dogs7Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/6_dogs-7/6_dogs-7';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '3-diamonds.png',
        '3-clubs.png',
        '2-spades.png',
        '2-hearts.png',
        '2-diamonds.png',
        '2-clubs.png'
    ] as const;
}
